import { PageTable, Header } from '/src/layouts/page';
import NiceModal from '@ebay/nice-modal-react';
import ApiModal from '/src/components/modal/ApiModal/ApiModal';
import migrationService from '../../services/migrationService';
import { useNavigate } from "react-router-dom";
import capitalizeFirstLetter from '../../../../../utils/capitalizeFirstLetter';
import Table from '/src/components/table';
import { formatDate } from '/src/utils/formatDate';
import "./MigrationTable.css";
import '/src/components/UI/Button/IconButton/IconButton.css';
import MigrationModal from '../MigrationModal/MigrationModal'
import MigrationModalImport from '../MigrationModal/MigrationModalImport';
import Field from '/src/components/UI/Field/Field';
import getCutToken from "/src/utils/getCutToken";
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
import hasPermission from '/src/utils/hasPermission';

function MigrationTable() {
    const { getMigrations, deleteMigration } = migrationService;
	const toast = useToastDispatchContext();
    const currentUser = JSON.parse(window.sessionStorage.getItem('user'));

    const cells = [
        {
            column: 'NAME',
            name: 'name',
            sort: true,
            show: (value) => capitalizeFirstLetter(value)
        },
        {
            column: 'TOKEN',
            name: 'secret_token',
            show: (value) => <span style={{ color: "var(--main)", cursor: "pointer" }} onClick={(e) => navigator.clipboard.writeText(value).then(_ => { toast.success('Copy token to clipboard', 'You can paste this token where you need !', 5000); })}> { getCutToken(value)} </span>
        },
        {
            column: 'LAST MIGRATION',
            name: 'updated_at',
            sort: true,
            show: (value) => formatDate(value)
        }
    ];
    const filters = [
        { type: 'input', placeholder: 'Name', name: 'term' }
    ]

    const showEditModal = ({ updateRow, row }) => {
        NiceModal.show(MigrationModal, {
            title: 'Modify your Migration',
            nameDataset: name,
            data: { ...row }
        }).then((statement) => updateRow(statement))
    }

    const showRunImportModal = ({ updateRow, row }) => {
        NiceModal.show(MigrationModalImport, {
            title: 'Run migration',
            nameDataset: name,
            data: { ...row }
        }).then((statement) => updateRow(statement))
    }

    const showAddModal = ({ addRow }) => NiceModal.show(MigrationModal, {
        nameDataset: name,
        title: 'Add your Migration',
    }).then((statement) => addRow(statement))

    const onClickDelete = ({ row, deleteRow }) => {
        const { id } = row;
        NiceModal.show(ApiModal, {
            title: 'Delete Migration ',
            body: 'Do you really want to delete migration for secret token bot ' + row.secret_token + " ?",
            api: {
                request: deleteMigration,
                param: [id]
            },
            buttons: [
                { className: 'validate', label: 'Cancel', style: { marginRight: '20px' }, onClick: () => { } },
                { className: 'cancel', label: 'Delete', type: 'submit' },
            ]
        }).then(() => deleteRow(id))
    };


    const actions = [
        hasPermission('update_migration') ? { className: "fas fa-edit action-button edit_action", style: {}, onClick: showEditModal } : null,
        hasPermission('view_migrations') ? { className: "fas fa-cloud action-button profil_action", style: { paddingLeft: "7px", paddingRight: "13px" }, onClick: showRunImportModal } : null,
        hasPermission('delete_migration') ? { className: "fas fa-trash action-button delete_action", style: {}, onClick: onClickDelete } : null,
    ].filter(action => action);

    const buttons = [
        hasPermission('create_migration') ? { icon: "fas fa-plus", onClick: showAddModal } : null
    ].filter(button => button);

    return (
        <PageTable>
            <Header title="List Migrations"></Header>
            <div className="entete-dataset">

                <div className="entete-dataset" style={{ width: "115px" }}>

                </div>
            </div>
            <div className="warning_migrations_container">
                <Field listClassName="warning_migrations">Running a migration can overwrite an existing Dataset or Bot which has the same name. Be careful !</Field>
            </div>
            <Table name="Migration" cells={cells} api={getMigrations} actions={actions} buttons={buttons} filters={filters}></Table>

        </PageTable>
    );
}

export default MigrationTable;